import '../App.css'
import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom"
import ReactMarkdown from 'react-markdown'
import { useLocation } from 'react-router-dom';
import apiHelper from '../helpers/apiHelper';
import { markdownComponents } from '../components/MarkdownComponents';

export default function Documents() {
    const [sections, setSections] = useState([]);
    const [selectedSection, setSelectedSection] = useState(null);
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const loadData = async () => {
            try {
                setLoading(true);
                const api = new apiHelper();
                const res = await api.GetDocumentSections();
                console.log(res);
                setSections(res);

                // Check for section parameter in URL
                const urlParams = new URLSearchParams(location.search);
                const sectionNum = urlParams.get('section');

                if (sectionNum !== null && res) {
                    // Find section by section number
                    const foundSection = res.find(s => s.section === parseInt(sectionNum));
                    if (foundSection) {
                        setSelectedSection(foundSection);
                    } else if (res.length > 0) {
                        // Select first section by default if section not found
                        setSelectedSection(res[0]);
                    }
                } else if (res && res.length > 0) {
                    // Select first section by default if no URL parameter
                    setSelectedSection(res[0]);
                }
            } catch (error) {
                console.error('Error loading document sections:', error);
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, [location.search]);

    const handleSectionSelect = (section) => {
        setSelectedSection(section);
        window.history.replaceState(null, "", "/Documents?section=" + section.section)
    }

    const getPageData = (section) => {
        try {
            return JSON.parse(section.pageData);
        } catch (error) {
            console.error('Error parsing pageData:', error);
            return { title: 'Error', content: 'Unable to load content' };
        }
    }

    return (
        <div>
            <main role="main" className="flex-shrink-0 min-vh-100">
                <div className='container-fluid px-0'>
                    <div className='row g-0'>
                        <div className='col-lg-2 col-md-3'>
                            <div className='sidebar-nav' style={{
                                backgroundColor: '#e7d2b7',
                                minHeight: 'calc(100vh - 110px)', /* Adjust based on navbar height */
                                borderRight: '4px solid #db9e4d'
                            }}>
                                <div className='sidebar-header' style={{
                                    backgroundColor: '#db9e4d',
                                    color: 'white',
                                    padding: '1rem 1.5rem',
                                    borderBottom: '2px solid #c8923f'
                                }}>
                                    <h5 className='mb-0 text-uppercase fw-bold' style={{
                                        fontFamily: 'Raleway, sans-serif',
                                        letterSpacing: '1px',
                                        fontSize: '0.9rem'
                                    }}>Document Sections</h5>
                                </div>
                                <div className='sidebar-body'>
                                    <Link
                                        className="nav-link"
                                        to="/Documents?section=0"
                                        reloadDocument
                                    >
                                        <button
                                            key="docHome"
                                            className="sidebar-section-item w-100 border-0 text-start px-3 py-3"
                                            style={{
                                                backgroundColor: 'transparent',
                                                color: '#8b6914',
                                                borderLeft: '4px solid transparent',
                                                borderTop: '1px solid #c8923f',
                                                borderBottom: '1px solid #c8923f',
                                                fontFamily: 'Raleway, sans-serif',
                                                fontWeight: '500',
                                                transition: 'all 0.3s ease'
                                            }}
                                        >
                                            <div className='d-flex justify-content-between align-items-center'>
                                                Documents Home
                                            </div>
                                        </button>
                                    </Link>
                                    {loading ? (
                                        <div className='px-3 py-4 text-center'>
                                            <div className="spinner-border" style={{ color: '#db9e4d' }} role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <p className='mt-2 mb-0' style={{ color: '#8b6914' }}>Loading sections...</p>
                                        </div>
                                    ) : sections.length > 1 ? (
                                        <div className='sidebar-sections'>
                                            {sections.filter(s => s.section !== 0).sort((a, b) => a.section - b.section).map((section) => {
                                                const pageData = getPageData(section);
                                                return (
                                                    <button
                                                        key={section.id}
                                                        className={`sidebar-section-item w-100 border-0 text-start px-3 py-3 ${selectedSection?.id === section.id ? 'active' : ''
                                                            }`}
                                                        onClick={() => handleSectionSelect(section)}
                                                        style={{
                                                            backgroundColor: selectedSection?.id === section.id ? '#db9e4d' : 'transparent',
                                                            color: selectedSection?.id === section.id ? 'white' : '#8b6914',
                                                            borderLeft: selectedSection?.id === section.id ? '4px solid #c54431' : '4px solid transparent',
                                                            borderTop: '1px solid #c8923f',
                                                            borderBottom: '1px solid #c8923f',
                                                            fontFamily: 'Raleway, sans-serif',
                                                            fontWeight: '500',
                                                            transition: 'all 0.3s ease'
                                                        }}
                                                    >
                                                        <div className='d-flex justify-content-between align-items-center'>
                                                            <span>{pageData.title}</span>
                                                            {section.isDraft && (
                                                                <small className='badge bg-warning text-dark'>Draft</small>
                                                            )}
                                                        </div>
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <div className='px-3 py-4'>
                                            <p className='text-muted mb-0'>No document sections available</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-10 col-md-9'>
                            <div className='content-area p-4'>
                                {loading ? (
                                    <div className='text-center py-5'>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className='mt-2 mb-0'>Loading content...</p>
                                    </div>
                                ) : selectedSection ? (
                                    <div>
                                        <h3 className='mb-4'>{getPageData(selectedSection).title}</h3>
                                        <div className='markdown-content'>
                                            <ReactMarkdown components={markdownComponents}>{getPageData(selectedSection).content}</ReactMarkdown>
                                        </div>
                                    </div>
                                ) : (
                                    <div className='text-center py-5'>
                                        <h4 className='text-muted'>Select a document section to view content</h4>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </main >
        </div >
    )
}